<template>
  <v-dialog :value="true" max-width="290">
    <v-card>
      <v-card-title class="headline">Apagar {{ title }}</v-card-title>
      <v-card-text>
        Você quer realmente apagar <b>{{ text }}</b>?
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="default" :disabled="deleting" text @click="$emit('canceled')">
          Não
        </v-btn>
        <v-btn color="error" :disabled="deleting" :loading="deleting" text @click="deleteItem()">
          Apagar {{ title }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios'
import { mapMutations } from 'vuex'

export default {
  name: 'deleteModal',
  props: {
    title: {
      type: String,
      default: 'Item'
    },
    text: {
      type: String,
      default: 'Item'
    },
    id: {
      required: true,
      type: [String, Number]
    },
    endpoint: {
      required: true,
      type: String
    }
  },
  data: () => ({
    deleting: false
  }),
  methods: {
    ...mapMutations(['SET_SNACKBAR']),
    deleteItem () {
      let vue = this
      vue.deleting = true

      axios.delete(vue.endpoint + '/' + vue.id)
        .then(response => {
          vue.deleting = false
          vue.SET_SNACKBAR({ text: 'Usuário apagado' })
          vue.$emit('deleted')
        })
        .catch(() => {
          vue.SET_SNACKBAR({ text: 'Houve um erro ao processar seu pedido, por favor tente novamente' })
          vue.deleting = false
          vue.$emit('error')
        })
    }
  }
}
</script>
